/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContractTypeV1Dto } from '../models/ContractTypeV1Dto';
import type { CreateContractTypeV1Dto } from '../models/CreateContractTypeV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchContractTypeV1Dto } from '../models/PatchContractTypeV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ContractTypesService {
  /**
   * @param requestBody
   * @returns ContractTypeV1Dto create entity
   * @throws ApiError
   */
  public static contractTypeControllerV1CreateV1(
    requestBody: CreateContractTypeV1Dto,
  ): CancelablePromise<ContractTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/contract-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param category Filter contract types by category. For FM contracts, the category is always "Service".
   * @returns ContractTypeV1Dto a entity list
   * @throws ApiError
   */
  public static contractTypeControllerV1FindAllV1(
    category?: 'Rental' | 'Service',
  ): CancelablePromise<Array<ContractTypeV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contract-types',
      query: {
        category: category,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static contractTypeControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contract-types',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid contractTypeId
   * @returns ContractTypeV1Dto the entity
   * @throws ApiError
   */
  public static contractTypeControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ContractTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/contract-types/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid contractTypeId
   * @param requestBody
   * @returns ContractTypeV1Dto the update entity
   * @throws ApiError
   */
  public static contractTypeControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchContractTypeV1Dto,
  ): CancelablePromise<ContractTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/contract-types/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid contractTypeId
   * @returns ContractTypeV1Dto the entity
   * @throws ApiError
   */
  public static contractTypeControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ContractTypeV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/contract-types/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
